// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
    },
};

export default class Wistia extends Component<Props> {
    componentDidMount() {
        const { video_id } = this.props.content;
        const customScripts = this.props.options && this.props.options.scripts;

        if (video_id === '') return;

        const media = document.createElement('script');
        media.src = `//fast.wistia.com/embed/medias/${video_id}.jsonp`;
        media.id = `wistia-media-${video_id}`;
        if (document.body) {
            document.body.appendChild(media);
        }

        if (customScripts) loadScripts(customScripts);
        else {
            const script = document.createElement('script');
            script.src = '//fast.wistia.com/assets/external/E-v1.js';
            script.id = `wistia-script-${video_id}`;
            if (document.body) {
                document.body.appendChild(script);
            }
        }
    }

    componentWillUnmount() {
        const { video_id } = this.props.content;

        const media = document.getElementById(`wistia-media-${video_id}`);
        if (media) {
            media.outerHTML = '';
        }

        const script = document.getElementById(`wistia-script-${video_id}`);
        if (script) {
            script.outerHTML = '';
        }
    }

    render() {
        const { video_id } = this.props.content;

        return (
            <div
                className="wistia_responsive_padding"
                style={{ padding: '56.25% 0 0 0', position: 'relative' }}
            >
                <div
                    className="wistia_responsive_wrapper"
                    style={{
                        height: '100%',
                        left: 0,
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                    }}
                >
                    <div
                        className={`wistia_embed wistia_async_${video_id} videoFoam=true`}
                        style={{ height: '100%', width: '100%' }}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Wistia.js